import { useAddCaseFormContext } from "../contexts/AddCaseFormContext";
import { RECORD_DATA_TYPE } from '@demandproai/shared';
import useUploadQueue from './useUploadQueue';
import { buildCaseFieldUpdateCallback } from '../utils/uploadUtils';

export default function useDedicatedFileUpload(caseId, caseRecordType) {
    const { isLoading, queueFiles } = useUploadQueue(caseId);
    const { incrementPresignedUrlCount, decrementPresignedUrlCount } = useAddCaseFormContext();

    const dedicatedFileUpload = async (files, updateCasePayload = null) => {
        try {
            const callback = updateCasePayload ? buildCaseFieldUpdateCallback(updateCasePayload) : null;
            const { filesWithMetadata } = await queueFiles({ files, caseRecordType, callback });
            return filesWithMetadata;
        } catch (error) {
            decrementPresignedUrlCount(files.length);
            throw error;
        }
    };

    const dedicatedImageUpload = async (imageFiles, updateCasePayload = null) => {
        try {
            const callback = updateCasePayload ? buildCaseFieldUpdateCallback(updateCasePayload) : null;
            const { filesWithMetadata } = await queueFiles({
                files: imageFiles,
                caseRecordType: RECORD_DATA_TYPE.IMAGE,
                callback,
            });
            return filesWithMetadata;
        } catch (error) {
            decrementPresignedUrlCount(imageFiles.length);
            throw error;
        }
    };

    const handleFileSelection = (files) => {
        dedicatedFileUpload(files);
    };

    return {
        isLoading,
        handleFileSelection,
        dedicatedFileUpload,
        dedicatedImageUpload,
        completeFileUpload: (count) => decrementPresignedUrlCount(count),
        startFileUpload: (count) => incrementPresignedUrlCount(count),
    };
}
